import { groupOverviewActionTypes } from './Constants';
import { change, destroy } from 'redux-form';

export function getActiveGroupsRequest(subjectId) {
	return {
		type: groupOverviewActionTypes.GET_ACTIVE_GROUPS_REQUEST,
		payload: {
			subjectId,
		},
	};
}

export function getActiveGroupsSuccess(activeGroups) {
	return {
		type: groupOverviewActionTypes.GET_ACTIVE_GROUPS_SUCCESS,
		payload: {
			activeGroups,
		},
	};
}

export function getActiveGroupsError(error) {
	return {
		type: groupOverviewActionTypes.GET_ACTIVE_GROUPS_ERROR,
		payload: {
			error,
		},
	};
}

export function getInvitedGroupsRequest() {
	return {
		type: groupOverviewActionTypes.GET_INVITED_GROUPS_REQUEST,
	};
}

export function getInvitedGroupsSuccess(invitedGroups) {
	return {
		type: groupOverviewActionTypes.GET_INVITED_GROUPS_SUCCESS,
		payload: {
			invitedGroups,
		},
	};
}

export function getInvitedGroupsError(error) {
	return {
		type: groupOverviewActionTypes.GET_INVITED_GROUPS_ERROR,
		payload: {
			error,
		},
	};
}

export function getRequestedGroupsRequest() {
	return {
		type: groupOverviewActionTypes.GET_REQUESTED_GROUPS_REQUEST,
	};
}

export function getRequestedGroupsSuccess(requestedGroups) {
	return {
		type: groupOverviewActionTypes.GET_REQUESTED_GROUPS_SUCCESS,
		payload: {
			requestedGroups,
		},
	};
}

export function getRequestedGroupsError(error) {
	return {
		type: groupOverviewActionTypes.GET_REQUESTED_GROUPS_ERROR,
		payload: {
			error,
		},
	};
}

export function deleteGroupRequest(groupId, route) {
	return {
		type: groupOverviewActionTypes.DELETE_GROUP_REQUEST,
		payload: {
			groupId,
			route,
		},
	};
}

export function deleteGroupSuccess(groupId) {
	return {
		type: groupOverviewActionTypes.DELETE_GROUP_SUCCESS,
		payload: {
			groupId,
		},
	};
}

export function deleteGroupError(error) {
	return {
		type: groupOverviewActionTypes.DELETE_GROUP_ERROR,
		payload: {
			error,
		},
	};
}

export function leaveGroupRequest(groupId, route) {
	return {
		type: groupOverviewActionTypes.LEAVE_GROUP_REQUEST,
		payload: {
			groupId,
			route,
		},
	};
}

export function leaveGroupSuccess(groupId) {
	return {
		type: groupOverviewActionTypes.LEAVE_GROUP_SUCCESS,
		payload: {
			groupId,
		},
	};
}

export function leaveGroupError(error) {
	return {
		type: groupOverviewActionTypes.LEAVE_GROUP_ERROR,
		payload: {
			error,
		},
	};
}

export function acceptInvitationRequest(groupId) {
	return {
		type: groupOverviewActionTypes.ACCEPT_INVITATION_REQUEST,
		payload: {
			groupId,
		},
	};
}

export function acceptInvitationSuccess(groupId) {
	return {
		type: groupOverviewActionTypes.ACCEPT_INVITATION_SUCCESS,
		payload: {
			groupId,
		},
	};
}

export function acceptInvitationError(error) {
	return {
		type: groupOverviewActionTypes.ACCEPT_INVITATION_ERROR,
		payload: {
			error,
		},
	};
}

export function declineInvitationRequest(groupId, navigatedFromGroupDetails = false) {
	return {
		type: groupOverviewActionTypes.DECLINE_INVITATION_REQUEST,
		payload: {
			groupId,
			navigatedFromGroupDetails,
		},
	};
}

export function declineInvitationSuccess(groupId) {
	return {
		type: groupOverviewActionTypes.DECLINE_INVITATION_SUCCESS,
		payload: {
			groupId,
		},
	};
}

export function declineInvitationError(error) {
	return {
		type: groupOverviewActionTypes.DECLINE_INVITATION_ERROR,
		payload: {
			error,
		},
	};
}

export function retractInvitationRequest(groupId, navigatedFromGroupDetails = false) {
	return {
		type: groupOverviewActionTypes.RETRACT_INVITATION_REQUEST,
		payload: {
			groupId,
			navigatedFromGroupDetails,
		},
	};
}

export function retractInvitationSuccess(groupId) {
	return {
		type: groupOverviewActionTypes.RETRACT_INVITATION_SUCCESS,
		payload: {
			groupId,
		},
	};
}

export function retractInvitationError(error) {
	return {
		type: groupOverviewActionTypes.RETRACT_INVITATION_ERROR,
		payload: {
			error,
		},
	};
}

export function handleConfirmationModal(status) {
	return {
		type: groupOverviewActionTypes.HANDLE_CONFIRMATION_MODAL,
		payload: {
			status,
		},
	};
}

export function joinGroupRequest(groupId, navigatedFromGroupDetails = false, query) {
	return {
		type: groupOverviewActionTypes.JOIN_GROUP_REQUEST,
		payload: {
			groupId,
			navigatedFromGroupDetails,
			query,
		},
	};
}

export function joinGroupSuccess() {
	return {
		type: groupOverviewActionTypes.JOIN_GROUP_SUCCESS,
	};
}

export function joinGroupError(error) {
	return {
		type: groupOverviewActionTypes.JOIN_GROUP_ERROR,
		payload: {
			error,
		},
	};
}

export function toggleCreateGroupModal(open, subjectId, isFromAddListModal = false) {
	return {
		type: groupOverviewActionTypes.TOGGLE_CREATE_GROUP_MODAL,
		payload: {
			open,
			subjectId,
			isFromAddListModal,
		},
	};
}

export function getEducationTypesRequest(countryId) {
	return {
		type: groupOverviewActionTypes.GET_EDUCATION_TYPES_REQUEST,
		payload: {
			countryId,
		},
	};
}

export function getEducationTypesSuccess(educationTypes) {
	return {
		type: groupOverviewActionTypes.GET_EDUCATION_TYPES_SUCCESS,
		payload: {
			educationTypes,
		},
	};
}

export function getEducationTypesError(error) {
	return {
		type: groupOverviewActionTypes.GET_EDUCATION_TYPES_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getSchoolsRequest(query, countryId) {
	return {
		type: groupOverviewActionTypes.GET_SCHOOL_REQUEST,
		payload: {
			query,
			countryId,
		},
	};
}

export function getSchoolsSuccess(schools) {
	return {
		type: groupOverviewActionTypes.GET_SCHOOL_SUCCESS,
		payload: {
			schools,
		},
	};
}

export function getSchoolsError(error) {
	return {
		type: groupOverviewActionTypes.GET_SCHOOL_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getInstitutesRequest(countryId) {
	return {
		type: groupOverviewActionTypes.GET_INSTITUTES_REQUEST,
		payload: {
			countryId,
		},
	};
}

export function getInstitutesSuccess(institutes) {
	return {
		type: groupOverviewActionTypes.GET_INSTITUTES_SUCCESS,
		payload: {
			institutes,
		},
	};
}

export function getInstitutesError() {
	return {
		type: groupOverviewActionTypes.GET_INSTITUTES_ERROR,
	};
}

export function setGroupInfo(createGroupInfo, options) {
	return {
		type: groupOverviewActionTypes.SET_GROUP_INFO,
		payload: { createGroupInfo, options },
	};
}

export function changeFormField(formName, fieldName, value) {
	return change(formName, fieldName, value);
}

export function resetForm(formName) {
	return destroy(formName);
}

export function createGroupRequest(group, isFromAddListModal) {
	return {
		type: groupOverviewActionTypes.CREATE_GROUP_REQUEST,
		payload: {
			group,
			isFromAddListModal,
		},
	};
}

export function createGroupSuccess(schools) {
	return {
		type: groupOverviewActionTypes.CREATE_GROUP_SUCCESS,
		payload: {
			schools,
		},
	};
}

export function createGroupError(error) {
	return {
		type: groupOverviewActionTypes.CREATE_GROUP_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getAvailableSubjectsRequest() {
	return {
		type: groupOverviewActionTypes.GET_AVAILABLE_SUBJECTS_REQUEST,
	};
}

export function getAvailableSubjectsSuccess(subjects) {
	return {
		type: groupOverviewActionTypes.GET_AVAILABLE_SUBJECTS_SUCCESS,
		payload: {
			subjects,
		},
	};
}

export function getAvailableSubjectsError(error) {
	return {
		type: groupOverviewActionTypes.GET_AVAILABLE_SUBJECTS_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getUserDetailsRequest() {
	return {
		type: groupOverviewActionTypes.GET_USER_DETAILS_REQUEST,
	};
}

export function getUserDetailsSuccess(userData) {
	return {
		type: groupOverviewActionTypes.GET_USER_DETAILS_SUCCESS,
		payload: {
			userData,
		},
	};
}

export function getUserDetailsError(error) {
	return {
		type: groupOverviewActionTypes.GET_USER_DETAILS_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function cleanCreateGroupModalState() {
	return {
		type: groupOverviewActionTypes.CLEAN_CREATE_GROUP_MODAL_STATE,
	};
}

export function cleanGroupOverviewState() {
	return {
		type: groupOverviewActionTypes.CLEAN_GROUP_OVERVIEW_STATE,
	};
}
